var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._t("default"),_c('vue-programmatic-invisible-google-recaptcha',{ref:"invisibleRecaptcha1",attrs:{"sitekey":_vm.getEnvCaptcha(),"elementId":'invisibleRecaptcha1',"badgePosition":'left',"showBadgeMobile":true,"showBadgeDesktop":true},on:{"recaptcha-callback":_vm.recaptchaCallback}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }